/**
 * @fileoverview added by tsickle
 * Generated from: util/cookie.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CookieUtil = /** @class */ (function () {
    function CookieUtil() {
    }
    /**
     * @param {?} key
     * @return {?}
     */
    CookieUtil.prototype.deleteCookie = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        document.cookie = key + "=;expires=" + new Date().toUTCString() + ";path=/";
    };
    /**
     * Return the cookie for the given name if set.
     */
    /**
     * Return the cookie for the given name if set.
     * @param {?} name
     * @return {?}
     */
    CookieUtil.prototype.getCookie = /**
     * Return the cookie for the given name if set.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        if (!document.cookie || document.cookie === '') {
            return null;
        }
        /** @type {?} */
        var cookieValue = null;
        document.cookie.split(';').some((/**
         * @param {?} cookie
         * @return {?}
         */
        function (cookie) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + "=")) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                return true;
            }
        }));
        return cookieValue;
    };
    return CookieUtil;
}());
/** @type {?} */
var cookieUtil = new CookieUtil();
export { CookieUtil, cookieUtil };
